import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StoreOnboardedDateQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type StoreOnboardedDateQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, onboarded_date?: string | null } | null };


export const StoreOnboardedDateDocument = gql`
    query storeOnboardedDate($id: ID!) {
  store(id: $id) {
    id
    onboarded_date
  }
}
    `;

/**
 * __useStoreOnboardedDateQuery__
 *
 * To run a query within a React component, call `useStoreOnboardedDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreOnboardedDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreOnboardedDateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStoreOnboardedDateQuery(baseOptions: Apollo.QueryHookOptions<StoreOnboardedDateQuery, StoreOnboardedDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreOnboardedDateQuery, StoreOnboardedDateQueryVariables>(StoreOnboardedDateDocument, options);
      }
export function useStoreOnboardedDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreOnboardedDateQuery, StoreOnboardedDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreOnboardedDateQuery, StoreOnboardedDateQueryVariables>(StoreOnboardedDateDocument, options);
        }
export type StoreOnboardedDateQueryHookResult = ReturnType<typeof useStoreOnboardedDateQuery>;
export type StoreOnboardedDateLazyQueryHookResult = ReturnType<typeof useStoreOnboardedDateLazyQuery>;
export type StoreOnboardedDateQueryResult = Apollo.QueryResult<StoreOnboardedDateQuery, StoreOnboardedDateQueryVariables>;